import { Controller } from "@hotwired/stimulus"

// Contrôleur pour gérer la sidebar mobile des espaces
export default class extends Controller {
  static targets = ["mobileDrawer"]

  connect() {
    // Fermer la sidebar mobile si on clique en dehors
    document.addEventListener('keydown', this.handleEscape.bind(this))
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape.bind(this))
  }

  toggleMobile() {
    if (this.hasMobileDrawerTarget) {
      this.mobileDrawerTarget.classList.toggle('hidden')
      document.body.classList.toggle('overflow-hidden')
    }
  }

  closeMobile() {
    if (this.hasMobileDrawerTarget) {
      this.mobileDrawerTarget.classList.add('hidden')
      document.body.classList.remove('overflow-hidden')
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.closeMobile()
    }
  }
}
